// Shared options for the Contacts-style address type dropdown.
export const CUSTOMER_ADDRESS_TYPE_OPTIONS = Object.freeze([
  { value: "billing", label: "Billing" },
  { value: "shipping", label: "Shipping" },
  { value: "both", label: "Both (Billing & Shipping)" },
]);

export function normalizeCustomerAddressType(value) {
  const type = String(value || "").trim().toLowerCase();
  if (!type) return "both";
  const aliases = {
    "bill to": "billing", "ship to": "shipping",
    "billing/shipping": "both", "shipping/billing": "both",
    "billing & shipping": "both", "billing and shipping": "both",
  };
  return aliases[type] || type;
}
